import { str } from "@lit/localize";
//#region src/generated/locales/de.ts
var templates = {
	"pd.sidebar.collapse": `Seitenleiste einklappen`,
	"pd.sidebar.expand": `Seitenleiste ausklappen`,
	"pd.edit.content.edit": `Edit`,
	"pd.moreInfo.more": `Mehr Informationen`,
	"pd.moreInfo.less": `Text ausblenden`,
	"pd.panel.viewer.aria.label": `Panel viewer`,
	"pd.panel.viewer.prev": `Previous panel`,
	"pd.panel.viewer.next": `Next panel`,
	"pd.panel.viewer.progress": `Panel navigation`,
	"pd.panel.viewer.panel": `Panel`,
	"pdContent.loadingstate.ariaLabel": `Ladevorgang`,
	"pdContent.loadingstate.ariaLoading": `Laden`,
	"pdContent.loadingstate.syncState": `Daten werden synchronisiert`,
	"pdContent.loadingstate.pleaseWait": `Bitte warten, Daten werden geladen`,
	"pdContent.badgeItem.titlePlaceholder": `Titel`,
	"pdContent.badgeItem.descPlaceholder": `Beschreibung`,
	"pdContent.badgeItem.save": `Speichern`,
	"pdContent.badgeItem.cancel": `Abbrechen`,
	"pdContent.badgeItem.editTitle": `Bearbeiten`,
	"pdContent.badgeItem.editAria": `Badge bearbeiten`,
	"pdContent.badgeItem.removeTitle": `Entfernen`,
	"pdContent.badgeItem.removeAria": `Badge entfernen`,
	"pdContent.badgeItem.addTitle": `Hinzufügen`,
	"pdContent.badgeItem.addAria": `Badge hinzufügen`,
	"pdContent.badgeItem.deleteTitle": `Löschen`,
	"pdContent.badgeItem.deleteAria": `Badge löschen`,
	"pdContent.badgeOrder.error.required": `Mindestens eine Badge auswählen`,
	"pdContent.badgeOrder.error.min": str`Mindestens ${0} Badges auswählen`,
	"pdContent.badgeOrder.error.max": str`Maximal ${0} Badges erlaubt`,
	"pdContent.badgeOrder.activeLabel": `Ausgewählt`,
	"pdContent.badgeOrder.availableLabel": `Verfügbar`,
	"pdContent.badgeOrder.emptyActive": `Badges hierher ziehen`,
	"pdContent.badgeOrder.emptyAvailable": `Keine weiteren Badges`,
	"pdContent.badgeOrder.activeHint": `Werden in dieser Reihenfolge angezeigt`,
	"pdContent.badgeOrder.availableHint": `Ziehe hierher, um zu deaktivieren`,
	"pdContent.badgeOrder.create": `Hinzufügen`,
	"pdContent.badgeOrder.aiTrigger": `KI-Assistent öffnen`
};
//#endregion
export { templates };
